import React, { useState, useEffect } from "react";

const PassportForm = () => {
  const [passportData, setPassportData] = useState({
    passportNumber: "",
    fullName: "",
    dateOfBirth: "",
    placeOfBirth: "",
    gender: "",
    nationality: "Indian",
    dateOfIssue: "",
    dateOfExpiry: "",
    placeOfIssue: "",
    fatherName: "",
    motherName: "",
    spouseName: "",
    address: "",
    image: null,
  });

  useEffect(() => {
    // Fetch existing passport details from the backend
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPassportData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setPassportData((prev) => ({ ...prev, image: e.target.files[0] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(passportData);
  };

  return (
    <div className="bg-gray-800 text-white shadow-lg rounded-xl p-6 mt-6 w-full">
      <h2 className="text-2xl font-bold text-center text-yellow-400 mb-6">
        Passport Application
      </h2>

      <form className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-4 items-start" onSubmit={handleSubmit}>
        {[
          { label: "Passport Number", name: "passportNumber", type: "text" },
          { label: "Full Name", name: "fullName", type: "text" },
          { label: "Date of Birth", name: "dateOfBirth", type: "date" },
          { label: "Place of Birth", name: "placeOfBirth", type: "text" },
          { label: "Date of Issue", name: "dateOfIssue", type: "date" },
          { label: "Date of Expiry", name: "dateOfExpiry", type: "date" },
          { label: "Place of Issue", name: "placeOfIssue", type: "text" },
          { label: "Father's Name", name: "fatherName", type: "text" },
          { label: "Mother's Name", name: "motherName", type: "text" },
          { label: "Spouse Name (if applicable)", name: "spouseName", type: "text" },
        ].map(({ label, name, type }) => (
          <div key={name} className="w-full">
            <label className="block text-gray-300 font-medium mb-1">{label}</label>
            <input
              type={type}
              name={name}
              value={passportData[name]}
              onChange={handleChange}
              required={name !== "spouseName"}
              className="w-full border rounded-md p-2 bg-gray-700 text-white focus:ring focus:ring-blue-400 outline-none"
            />
          </div>
        ))}

        <div className="w-full">
          <label className="block text-gray-300 font-medium mb-1">Gender</label>
          <select
            name="gender"
            value={passportData.gender}
            onChange={handleChange}
            required
            className="w-full border rounded-md p-2 bg-gray-700 text-white focus:ring focus:ring-blue-400 outline-none"
          >
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="col-span-1 md:col-span-2">
          <label className="block text-gray-300 font-medium mb-1">Address</label>
          <textarea
            name="address"
            value={passportData.address}
            onChange={handleChange}
            required
            style={{height: "200px"}}
            className="w-full border rounded-md p-2 bg-gray-700 text-white focus:ring focus:ring-blue-400 outline-none"
          />
        </div>

        <div className="col-span-1 md:col-span-2">
          <label className="block text-gray-300 font-medium mb-1">Upload Latest Image</label>
          <input
            type="file"
            onChange={handleFileChange}
            accept="image/*"
            required
            className="w-full border rounded-md p-2 bg-gray-700 text-white focus:ring focus:ring-blue-400 outline-none"
          />
        </div>

        <div className="col-span-1 md:col-span-2 flex justify-center mt-4">
          <button
            type="submit"
            className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-all"
          >
            Save Details
          </button>
        </div>
      </form>
    </div>
  );
};

export default PassportForm;
